import createTransition from 'shared-tokens/utils/createTransition';
import createBreakpoint from 'shared-tokens/utils/breakpoints';

import { mainCls as cardCls } from '../../style';

const brTablet = createBreakpoint('s');

export const mainCls =  `${cardCls}__strip`;

export default {
  [mainCls]: {
    borderRadius: '8px 8px 0 0',
    [brTablet]: {
      borderRadius: '4px 4px 0 0',
    },
    '&.c-bg--bg': {
      background: '#E3E6EA !important',
    },
  },
  [`${mainCls}__p`]: {
    display: '-webkit-box',
    '-webkit-line-clamp': 1,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    lineHeight: '18px',
    transition: createTransition(['max-height']),
    '&.expanded': {
      '-webkit-line-clamp': 2,
    },
  },
};
